import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';
import DistributionList from '@/api/Company/DistributionList';

class Company extends RestApiModel {
  static distributionLists = DistributionList;

  static getResourceEndpoint() {
    return '/companies';
  }

  static getAddressPhoneNumbers(id, addressId, params ) {
    let endpoint = this.getResourceIdEndpoint(id, 'addresses');
    endpoint = `${endpoint}/${addressId}/phone-numbers`;
    return this.all({params: params, endpoint: endpoint});
  }

  static producerStatuses() {
    return this.list({endpoint: '/companies/producer-statuses'});
  }

  static partnershipStatuses() {
    return this.list({endpoint: '/companies/partnership-statuses'});
  }

  static partnershipSeniorityOptions() {
    return this.list({endpoint: '/companies/partnership-seniority-options'});
  }

  static classificationDetailOptions() {
    return this.list({endpoint: '/companies/classification-detail-options'});
  }

  static salesCountries() {
    return this.list({endpoint: '/companies/sales-countries'});
  }

  static assignUsers(id, userIds) {
    return api.post(`${this.getResourceEndpoint()}/${id}/assign-users`, { userIds });
  }

  static companyCodeExists(companyCode) {
    return api.post(`${this.getResourceEndpoint()}/company-name-exists`, { companyCode });
  }

  /**
   *
   * @returns {Promise<AxiosResponse<any>>}
   */
  static coverholders() {
    return this.list({endpoint: '/companies/coverholders'});
  }

  /**
   *
   * @returns {Promise<AxiosResponse<any>>}
   */
  static producers() {
    return this.list({endpoint: '/companies/producers'});
  }

  /**
   *
   * @returns {Promise<AxiosResponse<any>>}
   */
  static placingBrokers() {
    return this.list({endpoint: '/companies/placing-brokers'});
  }

  /**
   *
   * @returns {Promise<AxiosResponse<any>>}
   */
  static lossAdjusters() {
    return this.list({endpoint: '/companies/loss-adjusters'});
  }

  /**
   *
   * @returns {Promise<AxiosResponse<any>>}
   */
  static insurers() {
    return this.list({endpoint: '/companies/insurers'});
  }

  static underwriterExecutives() {
    return this.list({endpoint: `/companies/underwriter-executives`});
  }

  static areaManagers() {
    return this.list({endpoint: `/companies/area-managers`});
  }

  static placingBrokersContacts() {
    return this.list({endpoint: `/companies/placing-brokers-contacts`});
  }

  /**
   *
   * @param companyId
   * @param targetCompanyId
   * @returns {*}
   */
  static copyCommercialProductsTo(companyId, targetCompanyId) {
    return api.get(`${this.getResourceIdEndpoint(companyId)}/copy-commercial-products-to/${targetCompanyId}`);
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static enable(id, isEnabled) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/enable`, {isEnabled});
  }
  
  /**
   * @param id
   * @param params
   * @returns {*}
   */
  static updateLogo(id, params) {
    return api.post(`${this.getResourceIdEndpoint(id)}/logo`, params);
  }
  
  /**
   * @param id
   * @returns {*}
   */
  static getLogo(id) {
    return api.get(`${this.getResourceIdEndpoint(id)}/logo`, { responseType: "blob" });
  }

  static getSalesCountry(id) {
    return api.get(this.getResourceIdEndpoint(id) + '/sales-country');
  }

  static addAllCommercialProductsFuwWithSalesCountry(id) {
    return api.get(this.getResourceIdEndpoint(id) + '/add-all-commercial-products-fuw-with-sales-country');
  }

  static addAllCommercialProductsProducerWithSalesCountry(id) {
    return api.get(this.getResourceIdEndpoint(id) + '/add-all-commercial-products-producer-with-sales-country');
  }

  static addAllCommercialProductsCoverholderWithSalesCountry(id) {
    return api.get(this.getResourceIdEndpoint(id) + '/add-all-commercial-products-coverholder-with-sales-country');
  }
  
  static removeCommercialProductsFuw(commercialProductIds, id) {
    return api.post(this.getResourceIdEndpoint(id) + '/remove-commercial-products-fuw', { commercialProductIds });
  }
  
  static removeCommercialProductsProducer(commercialProductIds, id) {
    return api.post(this.getResourceIdEndpoint(id) + '/remove-commercial-products-producer', { commercialProductIds });
  }
  
  static removeCommercialProductsCoverholder(commercialProductIds, id) {
    return api.post(this.getResourceIdEndpoint(id) + '/remove-commercial-products-coverholder', { commercialProductIds });
  }
}

export default Company;
